import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from '../api/axios'

const ActivateDependant = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')
  const queryEmail = queryParams.get('email')

  const [errMsg, setErrMsg] = useState('')
  const [loading, setLoading] = useState(true)
  const [policyId, setPolicyId] = useState(null)
  const [referredUser, setReferredUser] = useState(null)
  const [dependantInfo, setDependantInfo] = useState(null)

  // Step 1: Validate token
  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setErrMsg('Invalid or missing activation token.')
        setLoading(false)
        return
      }

      try {
        const response = await axios.post('/dependant/validate-token', { token })
        if (response?.data?.error) {
          throw new Error('Token validation failed')
        }
        setPolicyId(response?.data?.result?.policy_id)
        setReferredUser(response?.data?.result?.user)
        setDependantInfo(response?.data?.result?.dependant_info)
      } catch (error) {
        console.error(error)
        setErrMsg('Invalid or expired activation token.')
        setLoading(false)
      }
    }

    validateToken()
  }, [token])

  // Step 2: Fetch org details if token validation succeeded
  useEffect(() => {
    const fetchOrgDetails = async () => {
      if (!policyId) return

      try {
        const orgResponse = await axios.post(
          `${process.env.REACT_APP_KIS_BASE_URL}/api/v2/validate-organisation`,
          { policy_id: policyId, user: referredUser }
        )
        const orgDetails = {
          name: orgResponse.data.entity_name,
          postcode: orgResponse.data.entity_postcode,
          orgId: orgResponse.data.entity_id,
        }

        navigate(
          `/create-account/step-2`,
          {
            state: { orgDetails, referredUser, dependantInfo },
          }
        )
      } catch (error) {
        console.error(error)
        setErrMsg('Could not fetch organisation details.')
        setLoading(false)
      }
    }

    fetchOrgDetails()
  }, [policyId, navigate, token, queryEmail])

  if (loading && !errMsg) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Validating link...</p>
      </div>
    )
  }

  if (errMsg) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <h1 className="text-xl font-bold text-red-600 mb-4">Access Denied</h1>
        <p>{errMsg}</p>
      </div>
    )
  }

  return null
}

export default ActivateDependant
